export default function ChatgptSomeTwitter() {
  return <h2>Chatgpt Some Twitter</h2>;
}
